import React from 'react';

import { useTranslation } from 'react-i18next';

import Background from 'components/settings/projectConfiguration/branding/svgs/email/branding-email-bg.svg';
import Button from 'components/settings/projectConfiguration/branding/svgs/email/branding-email-buttonbg.svg';
import ButtonText from 'components/settings/projectConfiguration/branding/svgs/email/branding-email-buttontext.svg';
import Content from 'components/settings/projectConfiguration/branding/svgs/email/branding-email-content.svg';
import Links from 'components/settings/projectConfiguration/branding/svgs/email/branding-email-links.svg';
import Logo from 'components/settings/projectConfiguration/branding/svgs/email/branding-email-logo.svg';
import Powered from 'components/settings/projectConfiguration/branding/svgs/email/branding-email-powered.svg';

export default function EmailPreview({
  buttonBgColour,
  buttonTextColour,
  handshqLabel,
  logoSrc,
  primaryBgColour,
  textLinkColour,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'settings.projectConfiguration.branding.EmailPreview',
  });

  const imageContainerStyles = {
    left: '116px',
    height: '42px',
    top: '11px',
    bottom: '0px',
    width: '84px',
    position: 'relative',
  };

  const hasWhiteBackground = primaryBgColour === '#ffffff';

  return (
    <div
      className='svg-preview__document tw-bg-white'
      style={{ width: '315px', height: '408px' }}
    >
      <Content />
      <Background
        fill={primaryBgColour}
        stroke={hasWhiteBackground ? '#E4E5EB' : ''}
        stroke-dasharray={hasWhiteBackground ? '378 315' : ''}
      />
      <Button fill={buttonBgColour} />
      <ButtonText fill={buttonTextColour} />
      <Logo fill={primaryBgColour} />
      <Links fill={textLinkColour} />
      {handshqLabel && <Powered />}
      {logoSrc && (
        <div style={imageContainerStyles}>
          <img
            alt={i18nT('imageAlt')}
            className='image--bound-scaling'
            src={logoSrc}
          />
        </div>
      )}
    </div>
  );
}
